require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/fn/object/keys.js
 ** module id = 1215
 ** module chunks = 0
 **/